import { createOrEditActivity, updateActivityActiveStatus } from '../../../actions/areas/admin/commandActions';
import globals from '../../../globals/communityGlobals';

const activityWithDefaultValues = {
  activityTypeId: '',
  ragId: 1,
  duration: '0',
  description: '',
  bandId: 1,
  requiredClinicians: 1,
  timeAverage: 30,
  isActive: true,
  skillIds: [],
  varianceFactors: [{}],
  externalCode: '',
  orgUnitIds: [],
};
const locale = globals.getAreas(['activities', 'error', 'selectableListsValues']);

export const eventHandlers = (state, setState, auth) => {
  const handleSidePanel = (isOpen, data) => {
    // eslint-disable-next-line no-unused-expressions
    data != null
      ? setState(newState => ({
          ...newState,
          openSideActivityTypePanel: isOpen,
          activityWithDefaultValues: data,
        }))
      : setState(newState => ({ ...newState, openSideActivityTypePanel: isOpen, activityWithDefaultValues }));
  };
  const refreshTable = () =>
    setState(newState => ({
      ...newState,
      forceReload: !state.forceReload,
      isDataLoading: false,
      openSideActivityTypePanel: false,
      errorMsg: null,
    }));
  const updateTableProps = (currentPage, pageSize) => setState({ ...state, currentPage, pageSize });
  const updateTableSort = (sortColumn, sortDirection) => setState({ ...state, sortColumn, sortDirection });
  const errorCallback = response => {
    setState(newState => ({ ...newState, errorMsg: response, isDataLoading: false }));
    handleSidePanel(true);
  };

  const onClose = () => {
    setState(newState => ({ ...newState, openSideActivityTypePanel: false, errorMsg: null }));
  };

  return {
    locale,
    addButtonText: locale.getMsg('addButtonText'),
    refreshTable,
    handleSidePanel,
    updateTableProps,
    updateTableSort,
    onClose,
    createOrEditActivity: model => {
      setState(newState => ({ ...newState, isDataLoading: true }));
      createOrEditActivity(auth, model, refreshTable, errorCallback);
    },
    updateActiveStatus: model => {
      updateActivityActiveStatus(auth, model, refreshTable, errorCallback);
    },
  };
};
